var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "my-activities-card-config",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__("common.actions.configure"),
        primaryAction: {
          label: _vm.$t.__("common.actions.confirm"),
          action: function() {
            return _vm.confirmConfig()
          }
        },
        secondaryActions: [
          {
            label: _vm.$t.__("common.actions.cancel"),
            action: function() {
              return _vm.$emit("close")
            }
          }
        ]
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      [
        _c(
          "p",
          {
            staticClass:
              "typographies-paragraph-medium-regular my-activities-card-config__description"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__(
                    "dashboard.cards.MyActivitiesCardConfigDialog.description_dialog"
                  )
                ) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "CompassFormItem",
          {
            staticClass: "my-activities-card-config__select-spacing",
            attrs: {
              label: _vm.$t.__(
                "dashboard.cards.MyActivitiesCardConfigDialog.activity_label"
              )
            }
          },
          [
            _c(
              "CompassSelect",
              {
                staticClass: "my-activities-card-config__select",
                attrs: {
                  placeholder: _vm.$t.__("common.actions.select"),
                  multiple: "",
                  menuClass: "my-activities-card-config__select-menu"
                },
                model: {
                  value: _vm.filterByLabel.selectedOptions,
                  callback: function($$v) {
                    _vm.$set(_vm.filterByLabel, "selectedOptions", $$v)
                  },
                  expression: "filterByLabel.selectedOptions"
                }
              },
              _vm._l(_vm.filterByLabel.options, function(option) {
                return _c(
                  "CompassDropdownSelectOption",
                  _vm._b(
                    { key: option.id, attrs: { value: option.id } },
                    "CompassDropdownSelectOption",
                    option,
                    false
                  )
                )
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "CompassFormItem",
          {
            attrs: {
              label: _vm.$t.__(
                "dashboard.cards.MyActivitiesCardConfigDialog.activity_type_label"
              )
            }
          },
          [
            _c(
              "CompassSelect",
              {
                staticClass: "my-activities-card-config__select",
                attrs: {
                  placeholder: _vm.$t.__("common.actions.select"),
                  multiple: "",
                  menuClass: "my-activities-card-config__select-menu"
                },
                model: {
                  value: _vm.filterByType.selectedOptions,
                  callback: function($$v) {
                    _vm.$set(_vm.filterByType, "selectedOptions", $$v)
                  },
                  expression: "filterByType.selectedOptions"
                }
              },
              _vm._l(_vm.filterByType.options, function(option) {
                return _c(
                  "CompassDropdownSelectOption",
                  _vm._b(
                    { key: option.id, attrs: { value: option.id } },
                    "CompassDropdownSelectOption",
                    option,
                    false
                  )
                )
              }),
              1
            )
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }